<script setup lang="ts">
const topics = ['AI Agents', 'MCP Servers', 'LangChain', 'IoT', 'RISC-V', 'Nuxt']
</script>

<template>
  <section class="reveal-on-scroll border-t border-[var(--color-border)] bg-[var(--color-card-bg)] py-28">
    <div class="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
      <h2 class="mb-5 text-3xl font-bold text-[var(--color-text)] sm:text-4xl">
        Current Focus
      </h2>
      <p class="text-lg leading-relaxed text-[var(--color-text-muted)]">
        Building AI agents and MCP servers, bridging intelligent systems with IoT hardware,
        and shipping production platforms — all at once.
      </p>
      <div class="mt-10 flex flex-wrap items-center justify-center gap-3">
        <span
          v-for="topic in topics"
          :key="topic"
          class="rounded-full border border-[var(--color-amber)]/20 bg-[var(--color-amber)]/5 px-5 py-2 text-sm text-[var(--color-amber)] transition-all duration-300 hover:border-[var(--color-amber)]/40 hover:bg-[var(--color-amber)]/10 hover:shadow-[0_0_15px_rgba(250,185,91,0.1)]"
        >
          {{ topic }}
        </span>
      </div>
    </div>
  </section>
</template>
